import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [ 
        //首页
        {
            path: '/',
            name:'/',
            component: () => import("@/pages/Home/HomeIndex.vue"),
        },
        // 企业简介
        {
            path: '/intro',
            name:'/intro',
            component: () => import("@/pages/Home/IntroIndex.vue")
        },
        // 工程项目
        {
            path: '/article',
            name:'/article',
            component: () => import("@/pages/Home/ArticleIndex.vue")
        },
        // 企业资源
        {
            path: '/resource',
            name:'/resource',
            component: () => import("@/pages/Home/ResourceIndex.vue")
        },
        // 动态信息
        {
            path: '/message',
            name:'/message',
            component: () => import("@/pages/Home/MessageIndex.vue")
        },
        // 动态信息详情
        {
            path: '/messageDetails',
            name:'/messageDetails',
            component: () => import("@/pages/Home/MessageDetails.vue")
        },
        // 联系我们
        {
            path: '/my',
            name:'/my',
            component: () => import("@/pages/Home/MyIndex.vue")
        },
        // 新闻中心
        {
            path: '/new',
            name:'/new',
            component: () => import("@/pages/Home/NewsIndex.vue")
        },
        // 新闻中心详情
        {
            path: '/NewDetails',
            name:'/NewDetails',
            component: () => import("@/pages/Home/NewsDetails.vue")
        },
    ]
})



export default router;